import styled from "@emotion/styled";

import {
  MDSIcon,
  MDSIconKind,
  MDSTextField,
  MDSTextFieldSlotName,
  MDSTextFieldVariant,
} from "@/mds";

export const AgentFilterSearchField = ({
  ariaLabel,
  placeholder,
  value,
  onChange,
}: {
  ariaLabel: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
}) => (
  <StyledField
    aria-label={ariaLabel}
    placeholder={placeholder}
    value={value}
    variant={MDSTextFieldVariant.Filter}
    showClearTextButton
    onClearText={() => {
      onChange("");
    }}
    onChange={onChange}
  >
    <MDSIcon kind={MDSIconKind.Search} size={14} slot={MDSTextFieldSlotName.LeftAddon} />
  </StyledField>
);

/**
 * The `Filter` text-field variant is transparent and square by design, so the
 * pill background matching the filter chips beside it is applied here.
 *
 * The width is fixed rather than a percentage: a percentage `width` collapses
 * the field toward its minimum and clips the placeholder. 320px leaves room for
 * the longest placeholder ("Filter by name or project") alongside the search
 * icon and clear button, and `max-width` lets it shrink on narrow containers
 * rather than overflowing the filter bar. No `min-width` — it would win over
 * `max-width` and defeat that.
 */
const StyledField = styled(MDSTextField)`
  /* Doubled specificity to beat the variant styles on the base text field. */
  && {
    background: ${({ theme }) => theme.colors.background.button.toggle.default};
    border-radius: ${({ theme }) => theme.borderRadius.max};
    max-width: 100%;
    width: 320px;

    /* Matches MDSToggleButton's geometry so the field lines up with the filter
       chips beside it: 16px of content plus 8px of padding either side. The
       base field's 40px minimum and 20px side padding make it taller. */
    min-height: 32px;
    padding: ${({ theme }) => `${theme.spacing["2"]} ${theme.spacing["3"]}`};
  }
`;
